import { Tabs, Tab } from '@mui/material';
import styled from 'styled-components';

export const ToolbarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const StyledTabs = styled(Tabs)`
  min-height: 36px;

  .MuiTabs-indicator {
    background-color: ${({ theme }) => theme.palette.primary.main};
  }
`;

export const StyledTab = styled(Tab)`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.4px;
  text-transform: capitalize;
  min-height: 36px;
  padding: 6px 16px;
`;

export const MarkAllReadButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: 14px;
  font-weight: 400;
  padding: 6px 8px;
  border-radius: 4px;

  &:hover {
    background-color: ${({ theme }) => theme.palette.grey[100]};
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;

    &:hover {
      background: none;
    }
  }
`;

export const SearchInput = styled.div`
  width: 240px;
`;
